// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__r0YoA","title":"ClientCherryInfo_title__2Pdr1","itemText":"ClientCherryInfo_itemText__3FPYc"};